import { render, staticRenderFns } from "./CommentList.vue?vue&type=template&id=8e296c2c"
import script from "./CommentList.vue?vue&type=script&lang=js"
export * from "./CommentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports